import { render, staticRenderFns } from "./MotorsportCalendarPage.vue?vue&type=template&id=6afa8bc4&scoped=true"
import script from "./MotorsportCalendarPage.vue?vue&type=script&lang=ts"
export * from "./MotorsportCalendarPage.vue?vue&type=script&lang=ts"
import style0 from "./MotorsportCalendarPage.vue?vue&type=style&index=0&id=6afa8bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afa8bc4",
  null
  
)

export default component.exports